<template>
	<div id="app" class="d-flex flex-column h-100" :class="$store.state.bg_class">
		<app-bar />
		<router-view v-if="configLoaded" />
	</div>
</template>

<script>
import AppBar from '@/components/AppBar/AppBar.vue';

export default {
	name: 'AppContainer',
	components: { AppBar },
	data() {
		return { configLoaded: false };
	},
	watch: {
		'$store.getters.getBaseUrl': function setDefaultBaseUrl(v) {
			this.axios.defaults.baseURL = v;
		},
		'$store.getters.getAuthToken': function setDefaultCommonHeader(v) {
			this.axios.defaults.headers.common = { Authorization: `bearer ${v}` };
		},
	},
	created() {
		this.disablePageScrollingOnIpad();
	},
	mounted() {
		this.axios.get('config.json').then((response) => {
			if (response.status === 200) {
				this.$store.commit('setConfig', response.data);
				this.axios.defaults.baseURL = this.$store.getters.getBaseUrl;
				this.axios.defaults.headers.common = { Authorization: `bearer ${this.$store.getters.getAuthToken}` };

				// intercept all error responses and check for code 403
				this.axios.interceptors.response.use(
					(r) => r,
					(error) => {
						if (error.response.status === 401) {
							// session expired or invalid
							this.axios.defaults.headers.common = { Authorization: '' };
							this.$store.commit('setUser', null);
							this.$router.push('/signin');
						} else if (error.response.status === 403) {
							console.error(error.response.data.message);
						} else if (error.response.status === 409) {
							// 409: Conflict
							// While this may normally be a valid request that the user is permitted to do
							// (Hence not a 403 Forbidden) the user must take some option to resolve the state
							// of the database before they can proceed.
							if (error.response.data.message) {
								this.$bvToast.toast(error.response.data.message, {
									title: 'Error',
									variant: 'danger',
								});
							} else {
								this.$bvToast.toast(this.$t('generic.conflict'), {
									title: 'Error',
									variant: 'danger',
								});
							}
						}
						return Promise.reject(error);
					}
				);

				this.configLoaded = true;
			} else {
				this.$log.fatal('error loading config!');
			}
		});
	},
	methods: {
		/**
		 * Disables page scrolling (touching the background and moving) on iPad.
		 *
		 * This is necessary for for the RichNumberInput component to support dragging
		 * on iPad without the page being moved.
		 *
		 * @see https://stackoverflow.com/a/49853392/96205
		 */
		disablePageScrollingOnIpad() {
			const isIpad = navigator.maxTouchPoints > 0 && navigator.platform === 'MacIntel';

			if (isIpad) {
				window.addEventListener(
					'touchmove',
					(e) => {
						e.preventDefault();
					},
					{ passive: false }
				);
			}
		},
	},
};
</script>
